<div class="domainlogo side-container left" [class.invisible]="sideBlockLeft_hide$$()">
  <app-logo-header
    (onClickEmit)="onLogoClick()"
    [border]="true"
    [noClick]="noClick$$()"
    [url]="logoThumb_url$$()"
    >
    <div class="domaininfo">
      <div class="domainname">{{domain_name$$()}}</div>
    </div>
  </app-logo-header>
</div>
<div class="content" [class.withsub]="subTitle$$()">
  <div class="title">
    <h1>{{title$$()}}</h1>
    <div class="title-image">
      <ng-content select="[titleImage]" />
    </div>
  </div>
  @if (subTitle$$() && !subTitle_hide$$()) {
    <div class="subtitle">
      <h2>{{subTitle$$()}}</h2>
    </div>
  }
</div>
<div class="account-cluster side-container right" [class.invisible]="sideBlockRight_hide$$()">
  <app-button-navigation
    [matMenuTriggerFor]="accountMenu"
    [tooltip]="'account'"
    [tooltipPosition]="'below'"
    [tabindex]="-1"
    >
    <app-icon name="user" />
  </app-button-navigation>
  <!-- Ongelezen chatberichten (ChatPollingService); het chatoverzicht staat op Home. -->
  @if (chatUnread$$() > 0) {
    <span class="chat-unread">{{ chatUnread$$() }}</span>
  }
  <mat-menu #accountMenu="matMenu" xPosition="before">
    <button mat-menu-item class="account-menu-email"
      [matTooltip]="'home'"
      [matTooltipPosition]="'left'"
      (click)="gotoHome()"
      >{{ accountEmail$$() ?? '…' }}</button>
    <mat-divider />
    @if (chatUnread$$() > 0) {
      <button mat-menu-item (click)="gotoHome()">{{ text.chats }} ({{ chatUnread$$() }})</button>
    }
    <button mat-menu-item (click)="gotoPasswordChange()">Wachtwoord wijzigen</button>
    <button mat-menu-item (click)="gotoEmailChange()">E-mailadres wijzigen</button>
    <button mat-menu-item (click)="gotoSettings()">Instellingen</button>
    <button mat-menu-item (click)="logOut()">Uitloggen</button>
  </mat-menu>
</div>